import create from "zustand";
import { persist } from "zustand/middleware";
import moment from "moment";
import { DashboardQuery } from "../typings";

interface DashboardPrincipalStore {
  query: DashboardQuery;
  update: (prop: keyof DashboardQuery, value: any) => void;
  reset: () => void;
  reload: () => void;
}

export const useDashboardPrincipal = create<DashboardPrincipalStore>(
  persist(
    (set) => ({
      query: {
        dataInicio: moment().startOf("months").format("YYYY-MM-DD"),
        dataFim: moment().endOf("months").format("YYYY-MM-DD"),
        updatedAt: +new Date(),
      },
      update: (prop, value) => {
        set((state) => ({
          ...state,
          query: {
            ...state.query,
            [prop]: value,
          },
        }));
      },

      reload: () => {
        set((state) => ({
          ...state,
          query: {
            ...state.query,
            updatedAt: +new Date(),
          },
        }));
      },
      reset: () => {
        set((state) => ({
          ...state,
          query: {
            dataInicio: moment().startOf("months").format("YYYY-MM-DD"),
            dataFim: moment().endOf("months").format("YYYY-MM-DD"),
            updatedAt: +new Date(),
          },
        }));
      },
    }),
    {
      name: "@octopus-dashboard-principal",
      getStorage: () => localStorage,
    }
  )
);
